/**
 * View mode: tiles — 2×2 grid of equal squares.
 * Uses `currentColor`. No internal SVG padding — caller handles spacing.
 */
export function ViewTiles({ className, width = '1em', height = '1em', ...rest }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className={className}
      {...rest}
    >
      {/* 4 squares: 2px edge padding, 2px gap, 8×8 each */}
      <rect x="2"  y="2"  width="8" height="8" rx="0" />
      <rect x="14" y="2"  width="8" height="8" rx="0" />
      <rect x="2"  y="14" width="8" height="8" rx="0" />
      <rect x="14" y="14" width="8" height="8" rx="0" />
    </svg>
  )
}
